// This is intended to be used as a storage engine for redux-persist.
// When a user is authenticated, we persist in mongo instead of local storage.

import { getUserProfileUrl } from '../ajax/endpoints';

const setItem = (key, value) => {
  const url = getUserProfileUrl(key);
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    body: value,
  });
};

const getItem = key => {
  const url = getUserProfileUrl(key);
  return fetch(url, { credentials: 'include' })
  .then(response => response.text())
  .then(networkData => {
    // If we don't have data for this key, then check in local storage.
    // This is the typical case when logging in for the first time.
    // Here we will sync the local storage data into mongo, then clear the local storage.
    if (!networkData) {
      const localData = localStorage.getItem(key);
      if (localData) {
        return setItem(key, localData)
          .then(() => {
            localStorage.removeItem(key);
            return localData;
          }).catch(() => {
            return localData;
          })
        ;
      }
    }

    return networkData;
  });
};

const removeItem = key => {
  const url = getUserProfileUrl(key);
  return fetch(url, {
    credentials: 'include',
    method: 'DELETE',
  });
};

export default { getItem, setItem, removeItem };



// WEBPACK FOOTER //
// ./src/store/networkStorage.js